import { styled } from '../styles/styled'

const DisclaimerTypography = styled('div')({
  fontSize: '12px',
  color: '#a2a2a2',
})

export const Disclaimer = ({ content }: { content: string }) => {
  if (!content) return null
  return (
    <DisclaimerTypography
      className="small"
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  )
}
